module.exports = __webpack_public_path__ + "static/media/Sassuolo.ed8ce1a3.png";